import { AllowedCase } from 'src/types';
import { LOWERCASE_NOTICE_COPY, UPPERCASE_NOTICE_COPY } from '../constants/copy';

export const getTextCaseNotice = (allowedCase: AllowedCase) => {
  const cases: Record<NonNullable<AllowedCase>, string> = {
    upper: UPPERCASE_NOTICE_COPY,
    lower: LOWERCASE_NOTICE_COPY,
    mixed: '',
    'not applicable': '',
  };

  return allowedCase ? cases[allowedCase] : '';
};
